import React from 'react';
import Badge from '../Badge';
import { getOrderColorByStatusId, getOrderTypeLabelById } from '../../../Utils/Constants/Order';
import { TbClock } from 'react-icons/tb';
import { formatCartId } from '../../../Utils/Formatters';
import { ORDER_TYPE_STORE_COUNTER_ID } from '../../../Utils/Constants/Service';
import { useTranslation } from 'react-i18next';
import { MdOutlineTableRestaurant } from 'react-icons/md';

interface CardProfileOrderProps {
  order: any;
  onClick: CallableFunction;
}

const CardProfileOrder = ({order, onClick}: CardProfileOrderProps) => {

  const { t } = useTranslation();
  const displayCode = order.type === ORDER_TYPE_STORE_COUNTER_ID
                          ? order.cart_display_id ?? order.cart_id
                          : order.id;

  if (!displayCode) return null;

  return (
    <div className='w-full p-2 py-2.5 transition-all cursor-pointer hover:bg-gray-50 active:bg-gray-50 active:rounded-md active:ring-custom-primary'
      onClick={() => onClick(order) }
    >
      <div className='flex items-center justify-between gap-2 divide-x divide-gray-100'>
        <div className='font-bold text-lg text-shopfood-title leading-none w-14 flex-none text-right'>{formatCartId(displayCode)}</div>
        <div className='flex flex-col flex-grow px-2'>
          <div className='text-xs text-gray-400 flex flex-col'>
            <span className='flex items-center flex-wrap font-semibold gap-1 leading-none'><span>{t('layout.order_label')}</span> <span className='flex items-center flex-nowrap text-nowrap'>nº {order.id}</span></span>
            <span className='flex items-center flex-nowrap gap-0.5'><TbClock />{order.created_at_date_formatted}</span>
            
            {(order.type || order.table) &&
              <div className='flex flex-col md:flex-row md:items-center gap-0.5 md:gap-2 mt-0.5'>
                {order.type &&
                  <Badge className='self-start leading-none text-xs py-1 mt-0.5 normal-case'>
                    {getOrderTypeLabelById(order.type)}
                  </Badge>
                }
                {order.table &&
                    <div className='inline-flex items-center gap-0.5 font-medium text-xs leading-none mb-0.5 md:mb-0'>
                        <span className='text-sm'><MdOutlineTableRestaurant /></span>
                        {order.table?.name}
                    </div>
                }
              </div>
            }

          </div>
        </div>
        <Badge outline type={getOrderColorByStatusId(Number(order.status))} className="leading-none py-1 text-xs">
            {order.status_name}
        </Badge>
      </div>
    </div>
  )
}

export default CardProfileOrder;